// src/utils/audioUploader.js
import axios from 'axios';

export const getAudioResult = async (originalReadPresignedUrl, candidateReadPresignedUrl, audio1_filename, audio2_filename) => {
  const getTheResultUrl = 'https://lyjnc3rkugi7oo23xl755mneay0quplk.lambda-url.ap-south-1.on.aws/';
  const requestData = {
    audio_url_1: originalReadPresignedUrl,
    audio_url_2: candidateReadPresignedUrl,
    audio1_filename: audio1_filename,   
    audio2_filename: audio2_filename
};
    try {
    const response = await axios.post(getTheResultUrl, requestData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Failed to get the results:', error);
    return false;
  }
};